export default __webpack_public_path__ + "static/hero-8692a4c19b34bd5ffe75b1ec64425794.jpg";